import { BATCH_STEPPER } from 'constants/store.constants';

const selectBatchStepperSlice = (state) => state[BATCH_STEPPER];
export const selectActiveStep = (state) => selectBatchStepperSlice(state).activeStep;
export const selectActiveSubstep = (state) => selectBatchStepperSlice(state).activeSubstep;
export const selectSlideDirection = (state) => selectBatchStepperSlice(state).slideDirection;
export const selectSaveStatus = (state) => selectBatchStepperSlice(state).saveStatus;
